export const DASHBOARD_GRID_SETTINGS = {
  columns: 12,
  rowHeight: 50,
  gap: 10,
};
